import Backbone from 'backbone';

import { template } from '../template';

app.ImagePreview = Backbone.View.extend({
  className: 'image-preview',
  template: template('<img class="preview" src="<@= src @>" />'),

  initialize(options) {
    this.receiptWidthPercent = options.receiptWidthPercent;
    this.receiptPosition = options.receiptPosition;
    this.previewRenderId = 0;
    this.listenTo(this.model, 'change', this.render);
  },

  destroy() {
    this.previewRenderId += 1;
    this.stopListening(this.model);
  },

  renderReceiptFallback(widthPercent) {
    const width = Math.min(this.model.width(), (576 * widthPercent) / 100);
    const image = $('<img />')
      .attr('src', this.model.src())
      .addClass('receipt-preview-fallback')
      .css('width', `${(width / 576) * 100}%`);
    this.renderReceiptSample(
      image,
      'Black and white preview is unavailable. Printed image may differ.',
    );
  },

  renderReceiptSample(image, note) {
    this.$el.empty().append($('<div class="receipt-sample-image"></div>').append(image));
    this.$el.append(
      $('<span class="receipt-sample-note"></span>').text(note || 'Black and white image preview.'),
    );
    this.trigger('receipt-image-rendered');
  },

  renderReceipt(widthPercent) {
    const renderId = ++this.previewRenderId;
    this.$el.addClass('receipt-image-preview');
    this.$el.empty();
    if (!this.model.has('url') || this.model.has('image')) {
      this.renderReceiptSample(
        $('<span class="receipt-sample-placeholder"></span>').text(
          'Logo preview appears after upload.',
        ),
      );
      return this;
    }

    const image = new window.Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      if (renderId !== this.previewRenderId) {
        return;
      }
      const scale = Math.min(1, (576 * widthPercent) / 100 / image.width, 384 / image.height);
      const width = Math.max(1, Math.floor(image.width * scale));
      const height = Math.max(1, Math.floor(image.height * scale));
      const canvas = document.createElement('canvas');
      canvas.width = 576;
      canvas.height = height + 24;
      const context = canvas.getContext('2d');
      const sourceCanvas = document.createElement('canvas');
      sourceCanvas.width = width;
      sourceCanvas.height = height;
      const sourceContext = sourceCanvas.getContext('2d');
      if (!context || !sourceContext) {
        this.renderReceiptSample($('<span></span>').text('Preview is unavailable.'));
        return;
      }
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      const left = Math.floor((canvas.width - width) / 2);
      sourceContext.drawImage(image, 0, 0, width, height);
      try {
        const pixels = sourceContext.getImageData(0, 0, width, height);
        for (let offset = 0; offset < pixels.data.length; offset += 4) {
          const alpha = pixels.data[offset + 3] / 255;
          const luminance =
            (pixels.data[offset] * 299 +
              pixels.data[offset + 1] * 587 +
              pixels.data[offset + 2] * 114) /
            1000;
          const black = alpha >= 0.5 && alpha * luminance + (1 - alpha) * 255 < 220;
          pixels.data[offset] = black ? 0 : 255;
          pixels.data[offset + 1] = black ? 0 : 255;
          pixels.data[offset + 2] = black ? 0 : 255;
          pixels.data[offset + 3] = 255;
        }
        sourceContext.putImageData(pixels, 0, 0);
        context.drawImage(sourceCanvas, left, 12);
        this.renderReceiptSample(canvas);
      } catch {
        this.renderReceiptFallback(widthPercent);
      }
    };
    image.onerror = () => {
      if (renderId === this.previewRenderId) {
        this.renderReceiptFallback(widthPercent);
      }
    };
    image.src = this.model.src();
    return this;
  },

  render() {
    const receiptWidthPercent = this.receiptWidthPercent?.();
    if (receiptWidthPercent !== null && receiptWidthPercent !== undefined) {
      return this.renderReceipt(receiptWidthPercent);
    }
    this.previewRenderId += 1;
    this.$el.removeClass('receipt-image-preview');
    let width = this.model.width();
    let height = this.model.height();
    const ratio = width / height;
    let topPadding = 0;
    let leftPadding = 0;
    if (ratio >= 1) {
      width = 100;
      height = 100 / ratio;
      topPadding = (100 - height) / 2.0;
    } else {
      height = 100;
      width = 100 * ratio;
      leftPadding = (100 - width) / 2.0;
    }
    const src = this.model.src();
    this.$el.html(this.template({ src }));
    if (src) {
      this.$('img').css('margin', `${topPadding}% ${leftPadding}%`);
      this.$('img').css('width', `${width}%`);
      this.$('img').css('height', `${height}%`);
      this.$el.addClass('loading');
    } else {
      this.$el.removeClass('loading');
    }
    return this;
  },
});
